export const CHANNEL_CALLS = 1
export const CHANNEL_MESSAGES = 2
export const CHANNEL_VOICEMAILS = 3
export const CHANNEL_RECORDINGS = 4
export const CHANNEL_MENTIONS = 5
export const CHANNEL_INBOX = 6
export const CHANNEL_ALL_COMMUNICATIONS = 7
export const CHANNEL_VIEWS = 8
export const CHANNEL_MY_PERSONAL_LINE = 9
export const CHANNEL_TEAMINBOX = 10
